import ArrowNarrowShortUp from '../../Assets/Dashboard/ArrowNarrowShortUp.svg';
import ArrowNarrowShortDown from '../../Assets/Dashboard/ArrowNarrowShortDown.svg';

function StatCard({ statName, statValue, hasPrice, hasPercent, statTrend }) {
    return (
        <div className='border-[1px] border-[#EAEAEA] p-6 max-[1280px]:p-4 max-[1024px]:px-3 flex flex-col gap-1 max-[1152px]:gap-2 rounded-lg'>
            <h2 className='select-none font-semibold text-[14px] max-[1152px]:text-sm leading-[22px] text-[#666666]'>{statName}</h2>

            <div className="flex items-baseline justify-between">
                <div className="font-semibold w-full">
                    <h2 className='select-none text-[20px] max-[1152px]:text-base leading-8 text-[#121212] w-full line-clamp-1'>
                        {hasPrice && '₹'}
                        {statValue}
                        {hasPercent && '%'}
                    </h2>
                </div>

                {statTrend && <div className={`select-none rounded-xl ${statTrend > 0 ? 'bg-[#D1FAE5]' : 'bg-[#FEE2E2]'} h-fit px-[10px] py-[2px] max-[1152px]:px-2 flex items-center`}>
                    <div className="w-5 h-5 flex items-center justify-center">
                        {statTrend > 0 ? 
                            <img className='w-[10px] h-3' src={ArrowNarrowShortUp} alt="" /> :
                            <img className='w-[10px] h-3' src={ArrowNarrowShortDown} alt="" />
                        }
                    </div>

                    <h2 className={`trend-value font-semibold text-[14px] ${statTrend > 0 ? 'text-[#065F46]' : 'text-[#991B1B]'}`}>
                        {Math.abs(statTrend)}%
                    </h2>
                </div>}
            </div>
        </div>
    );
}

export default StatCard;
